import { render, staticRenderFns } from "./ChatEmojisDropdown.vue?vue&type=template&id=7ed01597&scoped=true"
import script from "./ChatEmojisDropdown.vue?vue&type=script&lang=js"
export * from "./ChatEmojisDropdown.vue?vue&type=script&lang=js"
import style0 from "./ChatEmojisDropdown.vue?vue&type=style&index=0&id=7ed01597&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed01597",
  null
  
)

export default component.exports